<script setup lang="ts">
import type { Colors, Tag, VueClass } from '@/api/types';
import { translateStringOrLocale } from '@/i18n';
import { computed, useAttrs } from 'vue';

const props = defineProps<{
  tags?: Pick<Tag, 'text' | 'color'>[];
  size?: 'badge-xs' | 'badge-sm' | 'badge-md' | 'badge-lg';
  color?: Colors;
  containerClass?: VueClass;
}>();

const translatedTags = computed(() =>
  props.tags?.map((t) => ({
    text: translateStringOrLocale(t.text).value,
    color: props.color ?? t.color ?? 'green-cyan',
  })),
);

defineOptions({
  inheritAttrs: false,
});
const attrs = useAttrs();
</script>

<template>
  <div
    v-for="(tag, idx) in translatedTags"
    :key="idx"
    class="tooltip max-w-full text-center"
    :class="containerClass"
    :data-tip="tag.text"
  >
    <p
      class="badge inline-flex max-w-full items-center truncate rounded-md text-center"
      :class="[
        attrs.class,
        `bg-gnist-${tag.color}`,
        {
          'p-2 pb-1 text-xs font-normal leading-tight': size === 'badge-xs',
          'p-3 text-sm font-semibold leading-tight': size === 'badge-sm',
          'p-4  text-base font-semibold leading-normal': size === 'badge-md',
          'p-5  text-lg font-semibold leading-normal': size === 'badge-lg',
        },
      ]"
    >
      {{ tag.text }}
    </p>
  </div>
</template>

<style scoped>
.tooltip:before {
  width: auto;
}
</style>
